import _defineProperty from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/regenerator/index.js";
import { useWallet } from '@solana/wallet-adapter-react';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Button } from './Button.mjs';
import { useWalletModal } from './useWalletModal.mjs';
import { WalletConnectButton } from './WalletConnectButton.mjs';
import { WalletIcon } from './WalletIcon.mjs';
import { WalletModalButton } from './WalletModalButton.mjs';
export var WalletMultiButton = function WalletMultiButton(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useWallet = useWallet(),
      publicKey = _useWallet.publicKey,
      wallet = _useWallet.wallet,
      disconnect = _useWallet.disconnect;

  var _useWalletModal = useWalletModal(),
      setVisible = _useWalletModal.setVisible;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      copied = _useState2[0],
      setCopied = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      active = _useState4[0],
      setActive = _useState4[1];

  var ref = useRef(null);
  var base58 = useMemo(function () {
    return publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58();
  }, [publicKey]);
  var content = useMemo(function () {
    if (children) return children;
    if (!wallet || !base58) return null;
    return base58.slice(0, 4) + '..' + base58.slice(-4);
  }, [children, wallet, base58]);
  var copyAddress = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!base58) {
              _context.next = 5;
              break;
            }

            _context.next = 3;
            return navigator.clipboard.writeText(base58);

          case 3:
            setCopied(true);
            setTimeout(function () {
              return setCopied(false);
            }, 400);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [base58]);
  var openDropdown = useCallback(function () {
    setActive(true);
  }, []);
  var closeDropdown = useCallback(function () {
    setActive(false);
  }, []);
  var openModal = useCallback(function () {
    setVisible(true);
    closeDropdown();
  }, [closeDropdown]);
  useEffect(function () {
    var listener = function listener(event) {
      var node = ref.current; // Do nothing if clicking dropdown or its descendants

      if (!node || node.contains(event.target)) return;
      closeDropdown();
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, closeDropdown]);
  if (!wallet) return React.createElement(WalletModalButton, _objectSpread({}, props), children);
  if (!base58) return React.createElement(WalletConnectButton, _objectSpread({}, props), children);
  return React.createElement("div", {
    className: "wallet-adapter-dropdown"
  }, React.createElement(Button, _objectSpread({
    "aria-expanded": active,
    className: "wallet-adapter-button-trigger",
    style: _objectSpread({
      pointerEvents: active ? 'none' : 'auto'
    }, props.style),
    onClick: openDropdown,
    startIcon: React.createElement(WalletIcon, {
      wallet: wallet
    })
  }, props), content), React.createElement("ul", {
    "aria-label": "dropdown-list",
    className: "wallet-adapter-dropdown-list ".concat(active && 'wallet-adapter-dropdown-list-active'),
    ref: ref,
    role: "menu"
  }, React.createElement("li", {
    onClick: copyAddress,
    className: "wallet-adapter-dropdown-list-item",
    role: "menuitem"
  }, copied ? 'Copied' : 'Copy address'), React.createElement("li", {
    onClick: openModal,
    className: "wallet-adapter-dropdown-list-item",
    role: "menuitem"
  }, "Change wallet"), React.createElement("li", {
    onClick: disconnect,
    className: "wallet-adapter-dropdown-list-item",
    role: "menuitem"
  }, "Disconnect")));
};